export default __webpack_public_path__ + "static/media/decor15.4940f65e.webp";